import { Button, IconButton, TextareaAutosize, TextField, Select, MenuItem } from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from 'Global';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import EventIcon from '@mui/icons-material/Event';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import App from "elements/HtmlEditor/App";
import { esES } from "@mui/x-date-pickers";
import "moment/locale/es";
import { useSnackbar, withSnackbar } from "notistack";
import moment from "moment";
import LangTabs from "elements/LangTabs";
import StructuredCommonsEditor from "./StructuredCommonsEditor";



export default withSnackbar(
  function FiestasEditor(props: any) {


    /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    /*============================================= */

    /*=======================================
      GET PROJECT ID AND ESTIMATE ID FROM URL
    =======================================*/
    let { fiesta_id } = useParams();
    /*=======================================
    =======================================*/


    const navigate = useNavigate();
    const defaultValues: any = {
      fiesta_id: fiesta_id ? fiesta_id : "null",
      titulo: "",
      image: "",
      date_data: null,
      bioHTML_primeras_visperas: "",
      bioJSON_primeras_visperas: null,
      bioHTML_oficio_lectura: "",
      bioJSON_oficio_lectura: null,
      bioHTML_laudes: "",
      bioJSON_laudes: null,
      bioHTML_horas_intermedias: "",
      bioJSON_horas_intermedias: null,
      bioHTML_visperas: "",
      bioJSON_visperas: null,
      bioHTML_completas: "",
      bioJSON_completas: null,
      bioHTML_lecturas: "",
      bioJSON_lecturas: null,
      common_meta: null,
      structured_content: { ready: false, model: null, items: [] }
    };

    const [loading, setLoading] = useState(false);
    const [formValues, setFormValues] = useState(defaultValues)
    const [files, setFiles] = useState<any>([]);

    // i18n: idioma actual y traducciones
    const [currentLangId, setCurrentLangId] = useState<string>("1");
    const [translations, setTranslations] = useState<Record<string, any>>({});
    const [structuredItems, setStructuredItems] = useState<any[]>([]);

    const getOfficialVariantLabel = (variant: any) => {
      if (typeof variant === "string") return variant;
      const label = String(variant?.label || "").trim();
      if (label) return label;
      const key = String(variant?.key || "").trim();
      return key ? key.replace(/_/g, " ") : "Variante";
    };


    const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
      const { name, value } = e.target;
      setFormValues({
        ...formValues,
        [name]: value,
      });
    };




    /*=======================================
      TEXT EDITOR
    =======================================*/
 
    const [initialContent1, setInitialContent1] = useState<any>(null);
    const [initialContent2, setInitialContent2] = useState<any>(null);
    const [initialContent3, setInitialContent3] = useState<any>(null);
    const [initialContent4, setInitialContent4] = useState<any>(null);
    const [initialContent5, setInitialContent5] = useState<any>(null);
    const [initialContent6, setInitialContent6] = useState<any>(null);
    const [initialContent7, setInitialContent7] = useState<any>(null);

    // Handler para cambio de idioma - SIMPLE como en Santoral
    const handleLangChange = (newLangId: string) => {
      setCurrentLangId(newLangId);
      // Actualizar los editores con el contenido heredado del nuevo idioma.
      const trans = translations[newLangId];
      if (trans) {
        setInitialContent1(trans.bioJSON_primeras_visperas || null);
        setInitialContent2(trans.bioJSON_oficio_lectura || null);
        setInitialContent3(trans.bioJSON_laudes || null);
        setInitialContent4(trans.bioJSON_horas_intermedias || null);
        setInitialContent5(trans.bioJSON_visperas || null);
        setInitialContent6(trans.bioJSON_completas || null);
        setInitialContent7(trans.bioJSON_lecturas || null);
      } else {
        setInitialContent1(null);
        setInitialContent2(null);
        setInitialContent3(null);
        setInitialContent4(null);
        setInitialContent5(null);
        setInitialContent6(null);
        setInitialContent7(null);
      }

      // El contenido estructurado puede ser muy grande (especialmente
      // Santos y Santas). Se carga por idioma bajo demanda y se mezcla con
      // lo ya editado para no perder cambios al alternar pestañas.
      const languageId = Number(newLangId);
      const alreadyLoaded = structuredItems.some(
        (item: any) => Number(item.lang_id) === languageId
      );

      if (fiesta_id && !alreadyLoaded) {
        axios
          .get(ProjectConfig.api_url, {
            params: {
              request: "fiesta_details",
              id: fiesta_id,
              lang_id: newLangId,
            },
          })
          .then((response) => {
            const incoming = response.data.structured_content?.items || [];
            setStructuredItems((current: any[]) => [
              ...current.filter(
                (item: any) => Number(item.lang_id) !== languageId
              ),
              ...incoming,
            ]);
          })
          .catch((err) => {
            console.log(err?.data || err);
          });
      }
    };

    // Helper para obtener el título según idioma
    const getCurrentTitulo = () => {
      if (currentLangId === "1") return formValues.titulo || "";
      return translations[currentLangId]?.titulo || "";
    };

    // Helper para actualizar traducciones
    const updateTranslation = (field: string, value: any) => {
      setTranslations(prev => ({
        ...prev,
        [currentLangId]: {
          ...prev[currentLangId],
          [field]: value
        }
      }));
    };

    // Handler para cambio de título
    const handleTituloChange = (e: { target: { value: any } }) => {
      const value = e.target.value;
      if (currentLangId === "1") {
        setFormValues({ ...formValues, titulo: value });
      } else {
        updateTranslation('titulo', value);
      }
    };


    const handleEditorChangeVisperas = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_visperas: htmlContent,
          bioJSON_visperas: jsonContent
        });
      } else {
        updateTranslation('bioHTML_visperas', htmlContent);
        updateTranslation('bioJSON_visperas', jsonContent);
      }
    }

    const handleEditorChangeOficio_lectura = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_oficio_lectura: htmlContent,
          bioJSON_oficio_lectura: jsonContent
        });
      } else {
        updateTranslation('bioHTML_oficio_lectura', htmlContent);
        updateTranslation('bioJSON_oficio_lectura', jsonContent);
      }
    }

    const handleEditorChangeLaudes = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_laudes: htmlContent,
          bioJSON_laudes: jsonContent
        });
      } else {
        updateTranslation('bioHTML_laudes', htmlContent);
        updateTranslation('bioJSON_laudes', jsonContent);
      }
    }

    const handleEditorChangeHoras_intermedias = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_horas_intermedias: htmlContent,
          bioJSON_horas_intermedias: jsonContent
        });
      } else {
        updateTranslation('bioHTML_horas_intermedias', htmlContent);
        updateTranslation('bioJSON_horas_intermedias', jsonContent);
      }
    }

    const handleEditorChangeCompletas = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_completas: htmlContent,
          bioJSON_completas: jsonContent
        });
      } else {
        updateTranslation('bioHTML_completas', htmlContent);
        updateTranslation('bioJSON_completas', jsonContent);
      }
    }

    const handleEditorChangeLecturas = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_lecturas: htmlContent,
          bioJSON_lecturas: jsonContent
        });
      } else {
        updateTranslation('bioHTML_lecturas', htmlContent);
        updateTranslation('bioJSON_lecturas', jsonContent);
      }
    }
    const handleEditorChangePrimeras_visperas = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          bioHTML_primeras_visperas: htmlContent,
          bioJSON_primeras_visperas: jsonContent
        });
      } else {
        updateTranslation('bioHTML_primeras_visperas', htmlContent);
        updateTranslation('bioJSON_primeras_visperas', jsonContent);
      }
    }
    /*=======================================
    =======================================*/

    const [colores, setColores] = useState<any[]>([]); 
    


    /*=======================================
      GET DETAILS IF EDITING
    =======================================*/
    useEffect(() => {
      axios
      .get(ProjectConfig.api_url, {
        params: {
          request: "all_colores",
        },
      })
      .then((response) => {
        // console.log(response.data)
        const coloresData = JSON.parse(response.data.colores);
        setColores(coloresData);
        // console.log(coloresData)
        // console.log(colores)
      })
      .catch((err) => {
        console.log(err.data);
      });

      if (fiesta_id) {
        // Cargar datos principales (ahora incluye translations)
        axios
          .get(ProjectConfig.api_url, {
            params: {
              request: "fiesta_details",
              id: fiesta_id,
              lang_id: "1",
            },
          })
          .then((response) => {

            setFormValues(response.data);
            
            setInitialContent1(response.data.bioJSON_primeras_visperas);
            setInitialContent2(response.data.bioJSON_oficio_lectura);
            setInitialContent3(response.data.bioJSON_laudes);
            setInitialContent4(response.data.bioJSON_horas_intermedias);
            setInitialContent5(response.data.bioJSON_visperas);
            setInitialContent6(response.data.bioJSON_completas);
            setInitialContent7(response.data.bioJSON_lecturas);

            // Cargar traducciones - vienen dentro de response.data.translations
            if (response.data.translations) {
              setTranslations(response.data.translations);
            }

            setStructuredItems(
              response.data.structured_content?.items || []
            );
           
          })
          .catch((err) => {
            console.log(err.data);
          });
      }
    }, []);
    /*=======================================
    =======================================*/

    



    // //  lISTADO DE COLERES
    // const colorsList = [
    //   { value: "red", label: "Rojo" },
    //   { value: "green", label: "Verde" },
    //   { value: "blue", label: "Azul" },
    //   // Agrega más colores según sea necesario
    // ];



    /*=======================================
      SUBMIT
    =======================================*/
    const [progress, setProgress] = useState(0);

    const checkForm = (): boolean => {

      let errors = false;

      if (formValues.titulo == "") {
        enqueueSnackbar("El nombre es obligatorio", { variant: "error", });
        errors = true;
      }
      // if (formValues.date == null) {
      //   enqueueSnackbar("La fecha es obligatoria", { variant: "error", });
      //   errors = true;
      // }

      return errors;
    }

    const handleSubmit = () => {
      // Preparar formValues con traducciones - IGUAL QUE SANTORAL
      const formValuesWithTranslations = {
        ...formValues,
        translations: translations
      };
      
      const formData = new FormData();
      formData.append("files", files);
      formData.append("formValues", JSON.stringify(formValuesWithTranslations));

      //AXIOS
      axios
        .post(ProjectConfig.api_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            setProgress(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
          params: {
            request: "add_edit_fiesta",
          },
        })
        .then(async (response) => {
          console.log(response);
          if (!response.data) {
            enqueueSnackbar("Error al guardar", { variant: "error" });
            return;
          }

          if (
            fiesta_id &&
            formValues.structured_content?.ready === true &&
            structuredItems.length > 0
          ) {
            const byLanguage = structuredItems.reduce(
              (acc: Record<string, any[]>, item: any) => {
                const key = String(item.lang_id || "1");
                acc[key] = acc[key] || [];
                acc[key].push(item);
                return acc;
              },
              {}
            );

            for (const [langId, items] of Object.entries(byLanguage)) {
              const structuredForm = new FormData();
              structuredForm.append("fiesta_id", fiesta_id);
              structuredForm.append("lang_id", langId);
              structuredForm.append("items", JSON.stringify(items));

              await axios.post(ProjectConfig.api_url, structuredForm, {
                params: {
                  request: "save_common_structured_content",
                },
              });
            }
          }

          navigate("/admin/fiestas");
        })
        .catch((err) => {
          console.log(err.data);
          enqueueSnackbar("Error al guardar", { variant: "error" });
        });
    }
    /*====================================
    =====================================*/


    const MIN_DATE = moment().subtract(350, 'years');




    return (
      <div id="userForm">
        <div className="userForm_right">
          <Box id="fiesta_editor" className="box_editor" title="Común" subtitle="Editar contenido litúrgico"  >
            {/* Language Tabs */}
            <LangTabs currentLangId={currentLangId} onChange={handleLangChange} />

            <div className='input_group'>
              <div className='input_group'>
                <div className='input_row'>

                  {/* UPLOAD button with preview - Solo en español */}
                  {currentLangId === "1" && (
                  <div className="drawerImagesContainer">

                    <div className="drawerImagesContainerDiv"
                      onDrop={(e) => {
                        e.preventDefault();
                        // UPDATE FILE
                        const files = e.dataTransfer.files;
                        setFiles(files[0]);
                        const fileArray = Array.from(files).map((file: any) => URL.createObjectURL(file));
                        setFormValues({
                          ...formValues,
                          image: fileArray[0],
                        });
                        e.currentTarget.classList.remove("dropzone_active");
                      }
                      }

                      onDragOver={
                        (e) => {
                          e.preventDefault();
                          e.currentTarget.classList.add("dropzone_active");
                        }

                      }
                      onDragLeave={
                        (e) => {
                          e.preventDefault();
                          e.currentTarget.classList.remove("dropzone_active");
                        }
                      }

                    >
                      {formValues.image && (
                        <img src={formValues.image} />
                      )}

                      <label id='dropFileDiv' className={formValues.image && ('showOnlyOnHover')}>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          className="addFile_button"
                          component="span"
                        >
                          <CameraAltIcon />
                          <input
                            type="file"
                            multiple
                            hidden
                            onChange={(e) => {
                              const files = e.target.files;
                              if (files) {

                                // UPDATE FILE
                                setFiles(files[0]);
                                const fileArray = Array.from(files).map((file: any) => URL.createObjectURL(file));
                                setFormValues({
                                  ...formValues,
                                  image: fileArray[0],
                                });

                              }

                            }}
                          />

                        </IconButton>
                      </label>

                    </div>

                  </div>
                  )}



                  <div className="inputColumn">
                    <TextField
                      id="titulo"
                      name="titulo"
                      label="Nombre canónico del común"
                      type="text"
                      required
                      fullWidth
                      value={getCurrentTitulo()}
                      onChange={handleTituloChange}
                      InputProps={{ readOnly: currentLangId === "1" }}
                    />

                    {/* Los Comunes no tienen fecha propia. */}

                  </div>
                </div>
              </div>


              {formValues.common_meta?.family_title && (
                <div style={{ margin: "8px 0 24px" }}>
                  <strong>{formValues.common_meta.family_title}</strong>
                  {formValues.common_meta.variant && (
                    <div>{formValues.common_meta.variant}</div>
                  )}
                  {formValues.common_meta.official_variants?.length > 0 && (
                    <details style={{ marginTop: "8px" }}>
                      <summary>Variantes litúrgicas oficiales</summary>
                      <ul>
                        {formValues.common_meta.official_variants.map((variant: any, index: number) => (
                          <li key={variant?.key || index}>
                            {getOfficialVariantLabel(variant)}
                          </li>
                        ))}
                      </ul>
                    </details>
                  )}
                </div>
              )}

              <div
                style={{
                  margin: "0 0 24px",
                  padding: 12,
                  border: "1px solid #ddd",
                  borderRadius: 6,
                }}
              >
                <strong>Presentación y acordeones</strong>
                <div style={{ marginTop: 6, marginBottom: 10 }}>
                  Los títulos de Misa, Leccionario, Liturgia de las Horas,
                  opciones y variantes se administran por idioma.
                </div>
                <Button
                  variant="outlined"
                  onClick={() => navigate(`/admin/idiomas/edit/${currentLangId}`)}
                >
                  Editar títulos y acordeones de este idioma
                </Button>
              </div>

              <StructuredCommonsEditor
                commonMeta={formValues.common_meta}
                structuredContent={formValues.structured_content}
                langId={currentLangId}
                items={structuredItems}
                onItemsChange={setStructuredItems}
              />

              <div style={{ marginTop: 36 }}>
                <h3>Liturgia de las Horas y contenido heredado</h3>
                <p>
                  Estos campos conservan el contenido histórico del módulo.
                  No equivalen a una certificación editorial de la nueva
                  estructura de Misa y Leccionario.
                </p>
              </div>
              
                <>
                <label>Primeras vísperas</label>
                  <App
                    key={`primeras_visperas-${currentLangId}`}
                    placeholder="Primeras vísperas"
                    handleEditorChange={handleEditorChangePrimeras_visperas}
                    content={initialContent1}
                  />
                  <label>Oficio de lectura</label>
                  <App
                    key={`oficio_lectura-${currentLangId}`}
                    placeholder="Oficio de lectura"
                    handleEditorChange={handleEditorChangeOficio_lectura}
                    content={initialContent2}
                  />
                  <label>Laudes</label>
                  <App
                    key={`laudes-${currentLangId}`}
                    placeholder="Laudes"
                    handleEditorChange={handleEditorChangeLaudes}
                    content={initialContent3}
                  />
                  <label>Horas intermedias</label>
                  <App
                    key={`horas_intermedias-${currentLangId}`}
                    placeholder="Horas intermedias"
                    handleEditorChange={handleEditorChangeHoras_intermedias}
                    content={initialContent4}
                  />
                  <label>Vísperas</label>
                  <App
                    key={`visperas-${currentLangId}`}
                    placeholder="Vísperas"
                    handleEditorChange={handleEditorChangeVisperas}
                    content={initialContent5}
                  />
                  <label>Completas</label>
                  <App
                    key={`completas-${currentLangId}`}
                    placeholder="Completas"
                    handleEditorChange={handleEditorChangeCompletas}
                    content={initialContent6}
                  />
                  <label>Lecturas de la Misa (contenido heredado)</label>
                  <App
                    key={`lecturas-${currentLangId}`}
                    placeholder="Lecturas de la Misa"
                    handleEditorChange={handleEditorChangeLecturas}
                    content={initialContent7}
                  />
                  
                </>
            

            </div>
            <div className='buttons'>
              <Button onClick={() => navigate(-1)} variant="outlined" className="button_2">Cancelar</Button>
              <Button
                onClick={() => {
                  if (!checkForm()) {
                    handleSubmit()
                  }
                }}
                variant="contained"
                className="button_1"
              >
                Guardar
              </Button>
            </div>
          </Box>
        </div>





      </div>

    );
  })